@if (!toggleOnly()) {
  <div class="border border-blister-border p-2 rounded-md">
    <div class="flex items-center justify-between gap-2">
      <div class="flex items-center gap-3">
        <div class="relative w-6 h-6 flex items-center justify-center">
          <i
            class="text-2xl pi {{ ionIcon() }}"
            [ngClass]="{
              'text-success': active(),
              'text-gray-500': !active(),
            }"
          ></i>

          @if (!active()) {
            <div
              class="absolute w-7 h-0.5 bg-danger rotate-45 rounded-full"
            ></div>
          }
        </div>

        <div>
          @if (description()) {
            <p class="text-slate-800 text-sm tracking-wide">
              <span [innerHTML]="description()"></span>
            </p>
          }
          <p
            class="text-base font-bold"
            [ngClass]="{
              'text-success': active(),
              'text-gray-500': !active(),
            }"
          >
            @if (active()) {
              <span [innerHTML]="activeText() ?? 'Activo'"></span>
            } @else {
              <span [innerHTML]="nonActiveText() ?? 'Inactivo'"></span>
            }
          </p>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="button" />
    </div>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="button" />
}

<ng-template #button>
  <button
    (click)="toggle()"
    [ngClass]="{
      'bg-success': active(),
      'bg-gray-300 ': !active(),
    }"
    class="relative w-12 h-6 transition-colors shrink-0 focus:outline-none toggle-dark"
  >
    <span
      [ngClass]="{
        'translate-x-6': active(),
        'translate-x-0': !active(),
      }"
      class="absolute top-0.5 left-0.5 w-5 h-5 bg-gray-100 shadow transition-transform duration-200"
    ></span>
  </button>
</ng-template>
